import React from 'react';

import { PageTitle } from '../../../components';

const Yoga = () => {
  return (
    <>
        <PageTitle title={'Joga'} page={'Joga'} heading={'Dwór Imielno'} />
      
        <div style={{ padding: '100px 20px', textAlign: 'center' }}>
          <h1>Joga</h1>
          <p>Sekcja w przygotowaniu.</p>
        </div>
        </>
  );
}

export default Yoga;